import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Alert, Grid, Typography } from "@mui/material"
import { AcademicLevel, Campus, ConsentementMultiple, RequiredFields, Submit } from "components"
import { Dropdown, Email, InputText, PhoneNumber } from "components/fields"
import formations from "../services/formation"
import { useForms, useSalesforce, useSubmission } from "hooks"
import { consent, consentement, defaultValues, getCampus } from "services"
import MentionsLegales from "components/MentionsLegales"
import { useState } from "react"
import { coalesceProductId, getProductIdFromLocation, resolveCampaignIdFromProductId } from "services/landingPageProductId"


const Form = ({
     optionsAcademicLevels, campMemberStatus = 'Contact Requested' }) => {
  const { recordTypeId, salesforce, setOpenSnackbar, setError } = useForms();
    const { submission } = useSubmission()
    const [isFormSent, setIsFormSent] = useState(false)

  // Styles
  // Form
   const methods = useForm({
    defaultValues: {
      ...consent,
      lead: {
        ...defaultValues,
        ...consentement
      }
    },
    resolver: yupResolver(schema)
  })
  const { control, reset } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const defaultDataLead = {
      Division__c: 'ISEG MCS',
      IONISSchool__c: 'ISEG MCS',
      LastForm__c: 'ISEG_LP_PSUP_26',
      LeadSource: 'LP : Demande de contact',
      RecordTypeId: recordTypeId
    }
    const finalLead = { ...lead, ...defaultDataLead }

    try {
      const productId = coalesceProductId(lead?.ProductId, getProductIdFromLocation())
      const campaignId = await resolveCampaignIdFromProductId({ salesforce, productId })

      await submission({
        campaignId,
        formId: 'CONTACT',
        lead: finalLead,
        campaignStatus: campMemberStatus,
        subject: 'Recontacter le prospect',
        description: 'Le prospect souhaite être recontacté.',
        utmCookieName: '_ionis_user_data'
      })
      const successUrl = new URL(window.location.href)
      successUrl.searchParams.set('sent', '1')
      window.history.replaceState({}, '', successUrl.toString())
      reset();
      setIsFormSent(true)
    }
    catch (error) {
      console.error('Erreur lors de la création du lead :', error?.response?.data ?? error)
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  useSalesforce('BusinessSchoolLead')

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      {isFormSent ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Alert severity="success">
              <Typography variant="h6" gutterBottom>
                Merci pour ton intérêt.
              </Typography>
              <Typography>
                Tu seras recontacté sous peu pour échanger sur ton projet.
              </Typography>
            </Alert>
          </Grid>
        </Grid>
      ) : (
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <AcademicLevel academics={['Terminale (BAC)', 'BAC', 'Bac +1', 'Bac +2', 'Autre']} options={optionsAcademicLevels} school="ISEG MCS" section={false} specialites={false} />
        <Grid item sm={6} xs={12}>
          <Campus label="Campus souhaité" options={getCampus('ISEG MCS')} />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Dropdown control={control} label="Quel parcours t'intéresse ?" name="lead.Wished_Programm__c" options={formations} required />
        </Grid>
        <ConsentementMultiple />
        <RequiredFields />
        <Submit label="Je souhaite être recontacté" onSubmit={onSubmit} />
        <MentionsLegales form="Contact" school="ISEG MCS" />
      </Grid>
      )}
    </FormProvider>
  )
}

export default Form
